module.exports = __webpack_public_path__ + "static/media/CornerCut_Before.3885c2ee.jpg";